@if (object1 | async; as item) {
  <div class="container influenza_Seasons_Card_Container">
    <div id="influenza-seasons-cards">
      <div class="row-flex m1-mobile">
        <div id="influnenza-complications-header" class="col-lg-12 col-md-12 col-sm-12 col-sm-12 text-center">
          <h2>
            <span>{{item.headLine}}</span>
            <div class="header-line"></div>
          </h2>
        </div>
        <div class="col-md-12 col-lg-5 col-sm-12 col-xs-12 influenza65_Left_Season_Card">
          <div id="season-card" class="two-row--card season-card-left season-left-width pt-6">
            <div class="two-row--card-content">
              <div class="two-row--card-top season-left-width">
                <p class="card-callout">
                  <div class="seasons-two-row--card-bottom">
                    <p class="card-content centered-text" [innerHTML]="item.content">
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- desktop-cards-->
          <div class="col-md-8 col-lg-7 col-sm-12 col-xs-12 influenza65_Right_Season_Card">
            <div id="season-card-right" class="two-row--card bg--white">
              <div class="two-row--card-content">
                <div class="two-row--card-top">
                  <p class="text--grey-110 card-header" [innerHtml]="item.text1content"></p>
                </div>
                <div class="two-row--card-bottom display--flex season-card-right-desktop">
                  <div class="mini-card bg--grey-0 col-md-4">
                    <div class="mini-card-1-container">
                      <p class="ash1" [innerHtml]="item.text2content"></p>
                    </div>
                  </div>
                  <div class="mini-card bg--grey-0 col-md-4">
                    <div class="mini-card-2-container">
                      <p class="ash1" [innerHTML]="item.text3content"></p>
                    </div>
                  </div>
                  <div class="mini-card bg--grey-0 text-left-align col-md-4">
                    <div class="mini-card-3-container">
                      <p class="one-block-text" [innerHtml]="item.text4content"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--mobile-cards-carousel-->
          <div id="carouselExampleIndicators" class="carousel slide col-md-8 col-lg-7 col-sm-12 col-xs-12" data-bs-ride="false">
            <div class="two-Row_Card_Top_Mobile">
              <p class="text_Grey_110" [innerHtml]="item.text1content"></p>
            </div>
            <div class="carousel_Container">
              <ol class="carousel-indicators">
                <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active"></li>
                <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"></li>
                <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2"></li>
              </ol>
              <div class="carousel-inner row-Card-Bottom_Mobile col-xl-12 col">
                <div class="active carousel-item">
                  <div class="mini_Card_Mobile bg--grey-0">
                    <div class="card_text_mobile" [innerHtml]="item.text2content"></div>
                  </div>
                </div>
                <div class="carousel-item">
                  <div class="mini_Card_Mobile bg--grey-0">
                    <div class="card_text_mobile" [innerHTML]="item.text3content"></div>
                  </div>
                </div>
                <div class="carousel-item">
                  <div class="mini_Card_Mobile bg--grey-0">
                    <div class="one-block-text" [innerHtml]="item.text4content"></div>
                  </div>
                </div>
              </div>
              <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-bs-slide="prev"
                class="d-none">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">{{"statictext.previous" | cxTranslate}}</span>
              </a>
              <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-bs-slide="next"
                class="d-none">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">{{"statictext.next" | cxTranslate}}</span>
              </a>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 influenza-season-footnotes">
            <p class="ash" [innerHTML]="item.bottomContent">
            </p>
          </div>
        </div>
      </div>
    </div>
  }